var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefundCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 7.5H3C2.05719 7.5 1.58578 7.5 1.29289 7.2071C1 6.9142 1 6.4428 1 5.5V3.5C1 2.55719 1 2.08578 1.29289 1.79289C1.58578 1.5 2.05719 1.5 3 1.5H9C9.9428 1.5 10.4142 1.5 10.7071 1.79289C11 2.08578 11 2.55719 11 3.5V6C11 6.46595 11 6.6989 10.9239 6.8827C10.8224 7.1277 10.6277 7.3224 10.3827 7.4239C10.1989 7.5 9.96595 7.5 9.5 7.5",
    stroke: "#3F3F3F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.5C7 5.05225 6.5523 5.5 6 5.5C5.4477 5.5 5 5.05225 5 4.5C5 3.94771 5.4477 3.5 6 3.5C6.5523 3.5 7 3.94771 7 4.5Z",
    stroke: "#3F3F3F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8.5C6.5 7.67155 7.17155 7 8 7V6C8 5.17155 8.67155 4.5 9.5 4.5V7.25C9.5 8.4173 9.5 9.00095 9.26385 9.4428C9.0774 9.79165 8.79165 10.0774 8.4428 10.2639C8.00095 10.5 7.4173 10.5 6.25 10.5H6C5.0681 10.5 4.60217 10.5 4.23463 10.3477C3.74457 10.1447 3.35523 9.7554 3.15224 9.26535C3 8.8978 3 8.4319 3 7.5",
    stroke: "#3F3F3F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefundCancel);
export default __webpack_public_path__ + "static/media/refund-cancel.641d0eb85b3536861914932d97542074.svg";
export { ForwardRef as ReactComponent };